/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";
import {
  getAuditActionDecoder,
  getAuditActionEncoder,
  type AuditAction,
  type AuditActionArgs,
} from ".";

/** Approval level configuration */
export type ApprovalLevel = {
  /** Action type requiring approval */
  actionType: AuditAction;
  /** Required approvers */
  requiredApprovers: Array<Address>;
  /** Minimum approval count */
  minApprovals: number;
  /** Timeout for approval process */
  approvalTimeout: bigint;
};

export type ApprovalLevelArgs = {
  /** Action type requiring approval */
  actionType: AuditActionArgs;
  /** Required approvers */
  requiredApprovers: Array<Address>;
  /** Minimum approval count */
  minApprovals: number;
  /** Timeout for approval process */
  approvalTimeout: number | bigint;
};

export function getApprovalLevelEncoder(): Encoder<ApprovalLevelArgs> {
  return getStructEncoder([
    ["actionType", getAuditActionEncoder()],
    ["requiredApprovers", getArrayEncoder(getAddressEncoder())],
    ["minApprovals", getU8Encoder()],
    ["approvalTimeout", getI64Encoder()],
  ]);
}

export function getApprovalLevelDecoder(): Decoder<ApprovalLevel> {
  return getStructDecoder([
    ["actionType", getAuditActionDecoder()],
    ["requiredApprovers", getArrayDecoder(getAddressDecoder())],
    ["minApprovals", getU8Decoder()],
    ["approvalTimeout", getI64Decoder()],
  ]);
}

export function getApprovalLevelCodec(): Codec<
  ApprovalLevelArgs,
  ApprovalLevel
> {
  return combineCodec(getApprovalLevelEncoder(), getApprovalLevelDecoder());
}
